import React, { useEffect, useState } from "react";
//import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
export default function MenuForm({
  onSubmit,
  loading = false,
  isEdit = false,
  initialData = {},
}) {
  const navigate = useNavigate();
  const initialState = {
    name: "",
    icon: "",
    slug: "",
    type: "",
    parentId: "",
    metaTitle: "",
    metaKeywords: "",
    metaDescription: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  
      //AUTO FILL EDIT DATA

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormData({
        name: initialData.name || "",
        icon: initialData.icon || "",
        slug: initialData.slug || "",
        type: initialData.type || "",
        parentId: initialData.parentId || "",
        metaTitle: initialData.metaTitle || "",
        metaKeywords: Array.isArray(initialData.metaKeywords)
          ? initialData.metaKeywords.join(", ")
          : initialData.metaKeywords || "",
        metaDescription:
          initialData.metaDescription || "",
      });
    }
  }, [initialData]);
  
     // VALIDATION
  
  /*const validationSchema = Yup.object({
    name: Yup.string()
      .trim()
      .max(50, "Menu title cannot exceed 50 characters")
      .required("Menu title is required"),
    icon: Yup.string()
      .required("Icon is required"),
    slug: Yup.string()
      .required("Slug is required"),
    type: Yup.string()
      .required("Type is required"),
    metaTitle: Yup.string()
      .required("Meta title is required"),
    metaKeywords: Yup.string()
      .required("Meta keywords are required"),
    metaDescription: Yup.string()
      .required("Meta description is required"),
  });*/
  
      //HANDLE CHANGE
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  
      //HANDLE SUBMIT
  
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    setErrors({});

    const payload = {
      name: formData.name,
      icon: formData.icon,
      slug: formData.slug,
      type: formData.type,
      parentId: formData.parentId || null,
      metaTitle: formData.metaTitle,
      metaKeywords: formData.metaKeywords
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean),
      metaDescription: formData.metaDescription,
    };

    

    const res = await onSubmit(payload);

    

    
   

if (!res?.success) {
  const backendErrors = res?.error || {};

  setErrors({
    common: res?.message || "Validation failed",

    name: backendErrors?.name || "",
    icon: backendErrors?.icon || "",
    slug: backendErrors?.slug || "",
    type: backendErrors?.type || "",
    parentId: backendErrors?.parentId || "",
    metaTitle: backendErrors?.metaTitle || "",
    metaKeywords: backendErrors?.metaKeywords || "",
    metaDescription: backendErrors?.metaDescription || "",
  });

  return;
}
    //  SUCCESS
    setSuccessMessage(
      isEdit
        ? "Menu Updated Successfully"
        : "Menu Added Successfully"
    );

    if (!isEdit) {
      setFormData(initialState);
    }

    setTimeout(() => {
      setSuccessMessage("");
      navigate("/menu");
    }, 1500);

  } catch (error) {
    

    setErrors({
      common:
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong",
    });
  }
};
  return (
    <div className="container-fluid p-4">
      <div className="card shadow border-0 p-4">
        <h3>
          {isEdit
            ? "Edit Menu"
            : "Add Menu"}
        </h3>
        {successMessage && (
          <div className="alert alert-success">
            {successMessage}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          {/* ROW 1 */}
          <div className="row h80">
            <div className="col-md-6">
              <label className="form-label">
                Menu Title<span className="error">*</span>
              </label>
              <input
                type="text"
                name="name"
                maxLength={50}
                className="form-control"
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.name}
                </div>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Icon<span className="error">*</span>
              </label>
              <input
                type="text"
                name="icon"
                className="form-control"
                value={formData.icon}
                onChange={handleChange}
              />
              {errors.icon && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.icon}
                </div>
              )}
            </div>
          </div>
          {/* ROW 2 */}
          <div className="row h80 mb-2">
            <div className="col-md-6">
              <label className="form-label">
                Slug<span className="error">*</span>
              </label>
              <textarea
                rows="1"
                name="slug"
                className="form-control"
                value={formData.slug}
                onChange={handleChange}
              />
              {errors.slug && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.slug}
                </div>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Type<span className="error">*</span>
              </label>
              <select
                name="type"
                className="form-select"
                value={formData.type}
                onChange={handleChange}
              >
                <option value="">
                  Select Type
                </option>
                <option value="MAIN">
                  MAIN
                </option>
                <option value="SUB">
                  SUB
                </option>
              </select>
              {errors.type && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.type}
                </div>
              )}
            </div>
          </div>
          {/* ROW 3 */}
          <div className="row h80">
            <div className="col-md-12">
              <label className="form-label">
                Select Parent Menu
              </label>
              <input
                type="text"
                name="parentId"
                className="form-control"
                value={formData.parentId}
                onChange={handleChange}
              />
            </div>
          </div>
          {/* SEO */}
          <h5 className="col-md-12 p-0">
            SEO Data
          </h5>
          {/* META TITLE */}
          <div className="row h80">
            <div
              className="col-md-12"
              style={{ minHeight: "85px" }}
            >
              <label className="form-label">
                Meta Title<span className="error">*</span>
              </label>
              <input
                type="text"
                name="metaTitle"
                className="form-control"
                value={formData.metaTitle}
                onChange={handleChange}
              />
              {errors.metaTitle && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.metaTitle}
                </div>
              )}
            </div>
          </div>
          {/* META KEYWORDS */}
          <div className="row h80">
            <div
              className="col-md-12"
              style={{ minHeight: "85px" }}
            >
              <label className="form-label">
                Meta Keywords<span className="error">*</span>
              </label>
              <input
                type="text"
                name="metaKeywords"
                className="form-control"
                value={formData.metaKeywords}
                onChange={handleChange}
                placeholder="seo, menu, home"
              />
              {errors.metaKeywords && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.metaKeywords}
                </div>
              )}
            </div>
          </div>
          {/* META DESCRIPTION */}
          <div className="row h120">
            <div
              className="col-md-12"
              style={{ minHeight: "160px" }}
            >
              <label className="form-label">
                Meta Description<span className="error">*</span>
              </label>
              <textarea
                rows="4"
                name="metaDescription"
                className="form-control"
                value={formData.metaDescription}
                onChange={handleChange}
              />
              {errors.metaDescription && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                  }}
                >
                  {errors.metaDescription}
                </div>
              )}
            </div>
          </div>
          {/* BUTTONS */}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading
                ? "Submitting..."
                : isEdit
                  ? "Update"
                  : "Submit"}
            </button>
            
         <button
  type="button"
  className="btn"
  style={{ backgroundColor: "#032B4D", color: "#fff" }}
  onClick={() => navigate("/menu")}
>
  Cancel
</button>
          </div>
        </form>
      </div>
    </div>
  );
}